import styled from "@emotion/styled";
import { Grid, TextField, Box } from "@mui/material";
import { useEffect, useState } from "react";
import CommonAutocomplete from "../../components/CommonAutocomplete";

const HeaderTextField = (props) => {
  return (
    <TextField
      InputLabelProps={{
        shrink: true,
      }}
      InputProps={{
        paddingInline: 0,
      }}
      {...props}
    >
      {props.children}
    </TextField>
  );
};
const SalesResultsHeader = styled(Grid)({
  margin: 0,
  marginTop: 10,
  padding: 0,
  display: "flex",
  justifyContent: "center",
});
const SALES_RESULTS_COLUMN_COUNT = 4;

export default function SalesResultsItem(props) {
  const {
    index,
    update,
    updateIndexProp,
    salesResults,
    apiSalesResults,
    buyers,
    focusNavigation,
    renderState,
    disableSalesResults,
    changeHistoryItem,
    changeHistoryItemsWithArray
  } = props;

  const [buyer, setBuyer] = useState({});
  const [quantityFocused, setQuantityFocused] = useState(false);

  useEffect(() => {
    update(index, {...salesResults, ...apiSalesResults[index]});
    setBuyer(
      buyers.find((x) => x.buyerNo === apiSalesResults[index]?.buyerNo) || null
    );
    renderState.update(`results-${index}`, true);
  }, [apiSalesResults]);

  useEffect(() => {
    updateIndexProp(index, "buyerNo", buyer?.buyerNo || "");
  }, [buyer]);

  async function handleBlur(e) {
    let newFocusArea;
    let newFocusRow;
    await new Promise((resolve) =>
      setTimeout(() => {
        newFocusArea = document.activeElement.id.split("-")[0];
        newFocusRow = parseInt(document.activeElement.id.split("-")[1]);
        resolve(); // Resolve the promise
      }, 0)
    );
    let blurredArea = e.target.id.split("-")[0];
    let blurredRow = parseInt(e.target.id.split("-")[1]);
    let updateValue = {};

    if (blurredRow !== newFocusRow || blurredArea !== newFocusArea) {
      const quantityHasValue = salesResults.quantity;
      const newHistoryItems = [];

      if (blurredRow > 0 && quantityHasValue) {
        for (let i = 0; i < SALES_RESULTS_COLUMN_COUNT; i++) {
          let aboveElement = document.getElementById(
            `salesResults-${blurredRow - 1}-${i}`
          );
          let blurredElement = document.getElementById(
            `salesResults-${blurredRow}-${i}`
          );
          if (blurredElement.value !== "" && blurredElement.value !== null)
            continue;
          if (i === 2) {
            let aboveBuyerNo = parseInt(
              aboveElement.value.split("-")[0].trim()
            );
            const selectedBuyer = buyers.find((x) => x.buyerNo === aboveBuyerNo);
            setBuyer(selectedBuyer);
            updateValue = { ...updateValue, ["buyerNo"]: aboveBuyerNo };
            newHistoryItems.push({
              itemName: `result-${blurredRow}-buyerNo`,
              value: aboveBuyerNo,
              valueName: selectedBuyer?.buyerName
            })
          } else {
            updateValue = {
              ...updateValue,
              [aboveElement.name]: aboveElement.value,
            };
            newHistoryItems.push({
              itemName: `result-${blurredRow}-${aboveElement.name}`,
              value: aboveElement.value,
              valueName: null
            })
          }
        }
        
        changeHistoryItemsWithArray(newHistoryItems);
      }

      const newSalesResults = { ...salesResults, ...updateValue };
      update(index, newSalesResults);
    }
  }

  return (
    // <Grid container my={0.5} onBlur={handleBlur} onFocus={handleFocus} justifyContent="start" display={"flex"}>
    <SalesResultsHeader
      container
      onBlur={handleBlur}
      id={`salesResultHeaderRow${index}`}
    >
      {/* <Grid item xs={12}> */}
      {/* 順 */}
      <Grid item xs={0.7}>
        <HeaderTextField
          sx={{ width: "90%" }}
          value={salesResults.salesDetailNo || ""}
          onChange={(e) => {
            updateIndexProp(index, "salesDetailNo", e.target.value)
            changeHistoryItem(`result-${index}-salesDetailNo`, e.target.value);
          }}
          name="salesDetailNo"
          id={`salesResults-${index}-0`}
          type="number"
          disabled={disableSalesResults}
        ></HeaderTextField>
      </Grid>
      {/* 単価 */}
      <Grid item xs={1.5}>
        <HeaderTextField
          sx={{ width: "90%" }}
          name="unitPrice"
          value={salesResults.unitPrice || ""}
          onChange={(e) => {
            updateIndexProp(index, "unitPrice", e.target.value);
            changeHistoryItem(`result-${index}-unitPrice`, e.target.value);
          }}
          id={`salesResults-${index}-1`}
          type="number"
          disabled={disableSalesResults}
        ></HeaderTextField>
      </Grid>
      {/* 買人 */}
      <Grid item xs={3.5}>
        <CommonAutocomplete
          value={buyer || null}
          onSelect={(e, newValue) => {
            setBuyer(newValue);
            focusNavigation(document.activeElement, false);
            changeHistoryItem(`result-${index}-buyerNo`, newValue?.buyerNo || '', newValue?.buyerName || null);
          }}
          name="buyerNo"
          id={`salesResults-${index}-2`}
          data={buyers}
          filterOptions={(options, { inputValue }) => {
            inputValue = inputValue.trim();
            return options.filter((x) => {
              return x.buyerNo.toString().startsWith(inputValue);
            });
          }}
          optionLabel={(option) =>
            option ? option.buyerNo + " - " + option.buyerName : ""
          }
          width="90%"
          disabled={disableSalesResults}
        />
      </Grid>
      {/* 数量 */}
      <Grid item xs={1.5}>
        <Box sx={{ position: 'relative', width: '90%' }}>
          <HeaderTextField
            sx={{
              width: "100%",
              '& input': {
                color: salesResults.isBara && salesResults.quantity && !quantityFocused ? 'transparent' : 'inherit',
              }
            }}
            name="quantity"
            value={salesResults.quantity || ""}
            onChange={(e) => {
              updateIndexProp(index, "quantity", e.target.value);
              changeHistoryItem(`result-${index}-quantity`, e.target.value);
            }}
            onFocus={() => setQuantityFocused(true)}
            onBlur={(e) => {
              setQuantityFocused(false);
              handleBlur(e);
            }}
            id={`salesResults-${index}-3`}
            type="number"
            disabled={disableSalesResults}
          />
          {salesResults.isBara && salesResults.quantity && !quantityFocused && (
            <Box
              sx={{
                position: 'absolute',
                top: '50%',
                left: '5px',
                transform: 'translateY(-50%)',
                border: '2px solid #2563eb',
                borderRadius: '999px',
                padding: '2px 8px',
                pointerEvents: 'none',
                backgroundColor: 'white',
                lineHeight: '20px',
              }}
            >
              {salesResults.quantity}
            </Box>
          )}
        </Box>
      </Grid>
      {/* コンテナ数 */}

      <Grid item xs={1.5}>
        <HeaderTextField
          sx={{ width: "90%" }}
          name="containerQuantity"
          value={salesResults.containerQuantity || ""}
          onChange={(e) => {
            updateIndexProp(index, "containerQuantity", e.target.value || 0);
            changeHistoryItem(`result-${index}-containerQuantity`, e.target.value || 0);
          }}
          id={`salesResults-${index}-4`}
          type="number"
          disabled={disableSalesResults}
        ></HeaderTextField>
      </Grid>

      {/* 備考 */}
      <Grid item xs={1.8}>
        <HeaderTextField
          sx={{ width: "90%" }}
          name="remarks"
          value={salesResults.remarks || ""}
          onChange={(e) => {
            updateIndexProp(index, "remarks", e.target.value || "");
            changeHistoryItem(`result-${index}-remarks`, e.target.value || "");
          }}
          disabled={disableSalesResults}
          placeholder={"入力例：11/11など"}
          id={`salesResults-${index}-5`}
        ></HeaderTextField>
      </Grid>

      {/* 金額 */}
      <Grid item xs={1.5}>
        <HeaderTextField
          sx={{ width: "100%" }}
          value={
            isNaN(salesResults.unitPrice) ||
            isNaN(salesResults.quantity) ||
            salesResults.unitPrice === "" ||
            salesResults.quantity === ""
              ? ""
              : salesResults.quantity * salesResults.unitPrice || ""
          }
          // id={`salesResults-${index}-6`}
          type="number"
          disabled
        ></HeaderTextField>
      </Grid>
      {/* </Grid> */}
    </SalesResultsHeader>
  );
}
